<mat-toolbar class="bg-white">
	Details
	<span fxFlex></span>
	<button [disableRipple]="true" mat-icon-button (click)="drawer.close()">
		<mat-icon>cancel</mat-icon>
	</button>
</mat-toolbar>
<div class="p-4">
	<div class="detail-section">
		<agm-map [zoom]="10" [latitude]="latitude" [longitude]="longitude" [fullscreenControl]="true">
			<agm-marker [latitude]="latitude" [longitude]="longitude"></agm-marker>
		</agm-map>

		<div class="summary-section mt-[25px] first:mt-0">
			<div class="__header uppercase py-2 px-0 border border-solid">
				<h4 *ngIf="location_name; else default">
					<b>{{ location_name }}</b>
				</h4>
				<ng-template #default>
					<h4>Summary</h4>
				</ng-template>
			</div>
			<div *ngFor="let item of summarySection | keyvalue">
				<div class="py-1 px-0">
					<p style="margin: 0">
						<b>{{ item.key }}:</b>
						{{ item.value }}
					</p>
				</div>
			</div>
		</div>
		<div class="summary-section" *ngIf="images.length !== 0">
			<div class="__header">
				<h4>Images</h4>
			</div>
			<portals-image-viewer [source]="images"></portals-image-viewer>
		</div>
	</div>
</div>
